import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 8 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.61914 5.38086C1.27743 5.03915 0.722568 5.03915 0.380859 5.38086C0.0391502 5.72257 0.0391502 6.27743 0.380859 6.61914L5.76172 12L0.380859 17.3809C0.0391502 17.7226 0.0391502 18.2774 0.380859 18.6191C0.722568 18.9608 1.27743 18.9608 1.61914 18.6191L7.61914 12.6191C7.96085 12.2774 7.96085 11.7226 7.61914 11.3809L1.61914 5.38086Z",
		fill: "black"
	})
});
export default SvgChevronRight;
